export default {
  id: 151,
  title: 'Target #151 - Pawn',
  url: 'https://cssbattle.dev/play/151',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#f5d6b4}a{position:fixed;background:#d86f45}[a]{top:135;left:150;width:100;height:65}[b]{top:55;left:175;width:50;height:50;border-radius:9in;box-shadow:90px 64px 0 45px #f5d6b4,-90px 64px 0 45px #f5d6b4}[c]{top:110;left:160;width:80;height:20;border-radius:10px 10px 20px 20px}[d]{top:205;left:130;width:140;height:40;border-radius:20px 20px 10px 10px}</style>',
}
